(function () {
  "use strict";

  function function_0885() {
    const style = document.createElement("style");
    style.textContent = `
    `;
    document.head.append(style);

    const button = document.querySelectorAll(".toggle");
    const content = document.querySelectorAll(
      "#shopify-section-header ul.mobile-nav-links > li > ul"
    );

    for (let i = 0; i < button.length; i++) {
      const tabButton = button[i];
      const tabContent = content[i];

      tabButton.onclick = function (e) {
        e.stopPropagation();
        if (tabButton.classList.contains("convx__mobile-nav-button-active")) {
          //close
          tabButton.classList.remove("convx__mobile-nav-button-active");
          tabContent.classList.remove("convx__mobile-nav-content-active");
        } else {
          //open
          tabButton.classList.add("convx__mobile-nav-button-active");
          tabContent.classList.add("convx__mobile-nav-content-active");
        }
      };
    }
  }

  function function_0818() {
    const style = document.createElement("style");
    style.textContent = `
                @media(max-width: 1024px) {
                    #chatra {
                        bottom: 110px!important;
                    }
                }
            `;
    document.head.append(style);
    // document.querySelector('#chatra').style.bottom = '110px'
  }

  function function_0822() {
    const style = document.createElement("style");
    style.textContent = `
            
            .convx__shoping-cart-header-container{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding-bottom: 20px;
            }
            .convx__shoping-cart-header-checkout-btn{
                border-radius: 25px;
            }
            .convx__shoping-cart-header-title{
                font-size: 2rem;
            }

            `;
    document.head.append(style);

    const container = document.createElement("div");
    container.classList.add("convx__shoping-cart-header-container");

    const leftContainer = document.createElement("div");
    leftContainer.classList.add("convx__shoping-cart-header-container-left");

    const rightContainer = document.createElement("div");
    rightContainer.classList.add("convx__shoping-cart-header-container-right");

    const btn = document.createElement("button");
    btn.classList.add(
      "convx__shoping-cart-header-checkout-btn",
      "button",
      "button-secondary"
    );
    btn.innerText = "CHECK OUT";

    const title = document.querySelector(
      "#shopify-section-cart > div > div > h2"
    );
    /* T5.48 — sections/cart.liquid is now a 34-byte stub; this custom cart
       header targets markup that no longer renders, so `title` is null and the
       next line threw an uncaught TypeError on every /cart page (polluting the
       Clarity error log). Bail out cleanly. */
    if (!title) return;
    title.style.display = "none";

    const price = document.querySelector(
      "#shopify-section-cart .cart-total-price"
    );

    const cartTitle = document.createElement("h3");
    cartTitle.classList.add("convx__shoping-cart-header-title");

    cartTitle.innerText = "MY CART";

    const total = document.createElement("span");
    total.classList.add("convx__shoping-cart-header-total-title");
    total.innerText = "TOTAL: " + price.innerHTML;

    rightContainer.append(btn);
    leftContainer.append(cartTitle);
    leftContainer.append(total);
    container.append(leftContainer);
    container.append(rightContainer);

    const location = document.querySelector(
      "#shopify-section-cart > div > div"
    );
    location.prepend(container);

    btn.onclick = function (event) {
      document.querySelector('.cart-totals [name="checkout"]').click();
    };
  }

  function function_0852() {
    const copyElement = document.getElementById("lkc-accessibility-copy");
    const copy = copyElement ? JSON.parse(copyElement.textContent) : {};
    const style = document.createElement("style");
    style.textContent = `
    .convx__end-page-cta-container{
      display: flex;
      flex-direction: column;
    }
    .convx__end-page-cta-box{
      justify-content: space-around;
      padding-bottom:25px;
    }
    .convx__end-page-cta-btn{
      display:flex;
    }
    .convx__end-page-sticky-cta a{
      width:100%;
    }
    .convx__end-page-sticky-cta{
      position: sticky;
      bottom:0;
      z-index:2;
      background: white;
    }
    #chatra{
      bottom:60px !important;
    }
    #smile-ui-lite-launcher-frame-container{
      bottom:60px !important;
    }
    @media (min-width:1024px){
    .convx__end-page-cta-container{
      display: flex;
      flex-direction: row;
      gap: 100px;
    }
    .convx__end-page-cta-box{
      justify-content: space-between;
    }

    @media  (max-width:640px){
      .convx__end-page-cta-header{
        text-align: center;
      }
      
    }
  }
    `;
    document.head.append(style);

    const items = [
      {
        header: "Explore",
        title: "Our most popular collections",
        link: "/collections",
      },
      {
        header: "Check out",
        title: "The Latest Collaborations",
        link: "/collections/collaborations",
      },
    ];

    const container = document.createElement("div");
    container.classList.add("grid-container", "convx__end-page-cta-container");

    items.forEach((item) => {
      const box = document.createElement("div");
      box.classList.add(
        "grid-x",
        "grid-margin-x",
        "align-middle",
        "align-justify",
        "mb-30s",
        "convx__end-page-cta-box"
      );

      const boxHeader = document.createElement("div");
      boxHeader.classList.add("cell", "medium-7", "convx__end-page-cta-header");
      box.append(boxHeader);

      const header = document.createElement("div");
      header.classList.add("overline-uppercase");
      header.innerHTML = item.header;
      boxHeader.append(header);

      const h2 = document.createElement("h2");
      h2.innerHTML = item.title;
      boxHeader.append(h2);

      const boxButton = document.createElement("div");
      boxButton.classList.add("cell", "medium-shrink");
      box.append(boxButton);

      const a = document.createElement("a");
      a.classList.add(
        "button",
        "button-primary",
        "button-rainbow",
        "convx__end-page-cta-btn"
      );
      a.setAttribute("href", item.link);
      boxButton.append(a);

      const span = document.createElement("span");
      span.textContent = item.link === "/collections/collaborations"
        ? (copy.viewCollaborations || item.title)
        : (copy.viewCollections || item.title);

      a.append(span);

      container.append(box);
    });
    const stickyCTA = document.createElement("div");
    stickyCTA.classList.add(
      "cell",
      "medium-shrink",
      "convx__end-page-sticky-cta"
    );

    stickyCTA.innerHTML = `
          <a class="button button-primary button-rainbow" href="/collections">
            <span></span>
          </a>
      `;

    stickyCTA.querySelector("span").textContent = copy.viewCollections || items[0].title;

    document.querySelector("#main").append(container);
    document.querySelector("#main").append(stickyCTA);

    //console.log("Sloth Here");
  }

  function function_0916() {
    const style = document.createElement("style");
    style.textContent = `

      #shopify-section-product .price-wrapper > h3 > span,
      #shopify-section-product .price-wrapper > h3 > s{
        display: none;
      }
      .convx__price-white-space, .convx__product-price, .convx__product-price-compare-at{
        display: block;
      }
      .convx__product-price-compare-at {
        padding-left: 4px;
        padding-right: 4px;
        text-decoration: line-through;
        color: #d73535;
      }
      .add-to-cart{
        margin-bottom: 0px;
      }
      .product-tile__title.h4.grid-x.align-middle{
         word-wrap: break-word; 
      }
      `;
    document.head.append(style);

    /* T5.36g (26 May 2026) — Added null guards. Both querySelectors below
       could return null on PDPs that don't render `.price-wrapper` or
       `.cell .quantity-wrapper` (e.g. one-variant products, A/B-test variants,
       or future template changes). When they returned null, `.append(null)`
       silently no-op'd but `.after(...)` on null threw TypeError — aborting
       the IIFE before CartDrawerSimplifying() (line 542) bound any handlers.
       Identified by code-audit as the #2 suspect for the Mobile Safari dead-
       click pattern (#1 being the breadcrumb pointer-events). */
    const priceWrapper = document.querySelector(".price-wrapper");
    const quantityWrapper = document.querySelector(".cell .quantity-wrapper");
    if (!priceWrapper || !quantityWrapper) {
      return; // Nothing to relocate — leave the page as Liquid rendered it.
    }
    const cell = document.createElement("div");
    cell.classList.add("cell", "convx__new-price-wrapper");
    cell.append(priceWrapper);
    quantityWrapper.after(cell);
  }

  function function_0887_v2() {
    const sort = document.querySelector(".sort-by-form");
    const stickyBar = document.querySelector(
      ".collection-filters-mobile-sticky"
    );
    const container = document.querySelector(".collection-toolbar__sort");
    const button = document.querySelector(
      ".collection-filters-mobile-opener.button.button-expanded.button-secondary"
    );
    const collectionToolbar = document.querySelector(".collection-toolbar");

    if (!stickyBar) {
      return;
    }
    //sort.classList.add("show-for-large");

    stickyBar.classList.remove("hide-for-large");
    stickyBar.classList.add("hide");

    const cloneButton = button.cloneNode(true);
    button.textContent = "Close";
    button.addEventListener("click", () => {
      collectionToolbar.classList.remove("open");
      stickyBar.classList.add("hide");
      document.body.classList.remove("popup-visible");
    });
    cloneButton.classList.add(
      "convx__find-my-style-button",
      "mb-20",
      "hide-for-large"
    );
    cloneButton.innerHTML = "Find My Style";
    cloneButton.addEventListener("click", () =>
      stickyBar.classList.remove("hide")
    );
    container.append(cloneButton);
  }

  // [P][Collections Pages] Feature Layout Fix (Mobile Only) - Variation
  function function_0983() {
    const style = document.createElement("style");
    style.textContent = `
                .collection-toolbar__sort{
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                }
                .collection-toolbar__sort form{
                    width: 100%;
                }
                .collection-toolbar__sort .collection-filters-mobile-opener{
                    min-width: 30%;
                    width: 30%;
                }
            `;
    document.head.append(style);

    waitForElementToDisplay(
      ".collection-toolbar__sort .collection-filters-mobile-opener",
      function () {
        const btn = document.querySelector(
          ".collection-toolbar__sort .collection-filters-mobile-opener"
        );

        btn.innerHTML = "Filter";
      },
      1000,
      60000
    );

    function waitForElementToDisplay(
      selector,
      callback,
      checkFrequencyInMs,
      timeoutInMs
    ) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
          return;
        } else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) return;
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }
  }

  function function_1029() {
    const style = document.createElement("style");
    style.textContent = ``;
    document.head.append(style);

    document
      .querySelectorAll("#collection-filters > div > ul")
      .forEach((btn) => {
        btn.setAttribute("hidden", "");
        btn.previousElementSibling.firstElementChild.setAttribute(
          "aria-expanded",
          "false"
        );
      });
  }

  function ShippingText() {
    waitForElementToDisplay(
      ".cart-modal-view .inside form .details .totals",
      function () {
        // Get the element to which you want to append the new content
        const container = document.querySelector(
          ".cart-modal-view .inside form .details .totals"
        );

        // Create a new element
        const shippingText = document.createElement("div");
        shippingText.className = "convx__shipping-text";
        shippingText.textContent = "Shipping calculated at checkout";

        // Append the new element to the container
        container.appendChild(shippingText);
      },
      1000,
      9000
    );

    function waitForElementToDisplay(
      selector,
      callback,
      checkFrequencyInMs,
      timeoutInMs
    ) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
          return;
        } else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) return;
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }
  }

function CartDrawerSimplifying() {
    if (window.cartDrawertest) {
      return;
    }

    window.cartDrawertest = true;

    const style = document.createElement("style");
    style.textContent = `
    .mu-free-gifts-container{
        /* display:none !important; */
    }
    .mu-savings.mu-pb-3.mu-flex.mu-items-center.mu-font-bold.mu-info-item {
        font-weight: 500 !important;
    }
    .mu-subtotal.mu-pb-3.mu-flex.mu-items-center.mu-font-bold.mu-info-item {
        font-weight: 500 !important;
    }
    button#mu-checkout-button {
        font-size: 1rem !important;
    }
    `;
    // document.head.append(style);

    // Function to process elements based on image source
    function processElements() {
      var elements = document.querySelectorAll(".mu-emoji-image");

      elements.forEach(function (element) {
        var img = element.querySelector("img");
        if (
          img &&
          img.src ===
            "https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif"
        ) {
          // Hide elements with the specific image source
          element.style.display = "none";
        } else {
          // Display other elements
          element.style.display = "block"; // or any other appropriate display value
        }
      });
    }

    function processWidget() {
      var elements = document.querySelectorAll(".mu-free-gifts-container");

      elements.forEach(function (element) {
        var before = element.querySelector(
          '.mu-free-gift[data-status="before"]'
        );
        var after = element.querySelector('.mu-free-gift[data-status="after"]');
        var header = element.querySelector(
          ".mu-free-gifts-container .mu-text-center.mu-p-2.mu-border-b"
        );
        var headerContent = header.querySelector("p");

        var widgetDesc = element.querySelector(".mu-widget div:first-child");

        const parentElement = element.querySelector(".mu-widget");

        if (before) {
          if (!parentElement.dataset.appendStatus) {
            parentElement.insertBefore(headerContent, parentElement.firstChild);
            parentElement.dataset.appendStatus = "true";
          }
          header.style.display = "none";
          header.style.padding = "0";
          widgetDesc.style.display = "none";
        }

        if (after) {
          header.style.display = "none";
        } else {
          header.style.display = "block";
        }
      });
    }

    // Initial processing of elements
    // processElements();
    // processWidget();

    // Create a MutationObserver to observe changes in the DOM
    var observer = new MutationObserver(function (mutations) {
      // Check for added nodes and process elements if needed
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          // processElements();
          // processWidget();
        }
      });
    });

    // Configure and start the observer
    var observerConfig = { childList: true, subtree: true };
    observer.observe(document.body, observerConfig);
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";
    const isMobile = window.screen.width <= 1023;
    const isAboutUS =
      path.includes("/pages/our-values") ||
      path.includes("/pages/about-us") ||
      path.includes("/pages/our-processes");

    CartDrawerSimplifying();
    ShippingText();
    if (isMobile) {
      // function_0885();
    }

    if (isProducts) {
      // T5.38 (29 May 2026) - Disabled function_0916. It ran on DOMContentLoaded
      // and physically MOVED the .price-wrapper node (Afterpay + Refundid + price)
      // out of its Liquid-rendered position into a new flex cell beside
      // .quantity-wrapper. That post-paint DOM move collapsed everything below it
      // upward = the "product section bounces up on load" CLS. The class it created,
      // .convx__new-price-wrapper, exists nowhere in Liquid - proof the move was
      // JS-only. This was tagged [A/B Test] "Variation"; we're reverting to the
      // test's Control = the natural, deliberately-designed layout. No DOM move,
      // no layout shift. The function definition (~line 247) is left in place but
      // is never called.
      // function_0916(); //[P][A/B Test][Product Page] Layout Adjustment - Variation
    }

    if (isCollections) {
      //function_0818(); //Collection Page - Remove Chat Overlap on Refine Feature

      //function_1029(); //[Collections Pages]Filter Issue on Desktop

      if (isMobile) {
        function_0887_v2(); //[P][Collection Page] Sort By and Refine Test - Variation 1
        function_0983(); //[P][Collections Pages] Feature Layout Fix (Mobile Only) - Variation
      }
    }

    if (isAboutUS) {
      function_0852();
    }

    if (isCart) {
      setTimeout(function () {
        function_0822();
      }, 2500);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
